import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { ReceiptRenderer } from './RecursiveSummaryReceipt';
import { SCUILoadingLinear, SCUIButton } from '../../../atomic/atoms';

import TimeHelper from '../../../utils/time';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { SV } from '../summaryV2.classes';

export const SummaryDetailV2 = ({ summary, setSummary, getSummaryList }: any) => {
    const [isLoading, setIsLoading] = useState(false);

    const { t } = useTranslation();

    return summary?.id ? (
        <Box className={SV.detail}>
            {isLoading && (
                <Box className={SV.detailLoading} sx={{ margin: '24px 0 24px 0 ' }}>
                    <SCUILoadingLinear display={isLoading} />
                </Box>
            )}
            <Box
                className={SV.detailBackBar}
                sx={{
                    display: 'flex',
                    alignItems: 'left',
                    marginBottom: '12px',
                    marginTop: '12px',
                    '& .sc-btn__text': {
                        padding: '8px !important',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                }}
            >
                <SCUIButton
                    className={SV.btnBack}
                    text={t('general.back')}
                    type="primary"
                    sizeType="fixed"
                    buttonType="button"
                    size={'m'}
                    showStartIcon
                    startIcon={<ArrowBackIosNewIcon sx={{ fontSize: '16px', color: '#fff' }} />}
                    onClick={() => {
                        setSummary({});
                    }}
                />
            </Box>
            <Box className={SV.detailBody} sx={{ padding: '24px', mx: 'auto' }}>
                <Box
                    className={SV.detailCard}
                    sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '24px',
                        flexDirection: 'column',
                        border: '1px solid #a0a0a0',
                        borderRadius: '8px',
                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <Box
                        className={SV.detailHeader}
                        sx={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}
                    >
                        <p className={SV.detailHeaderLabel} style={{ fontSize: '14px', fontWeight: '600' }}>
                            {t('summary.summaryDate')}:
                        </p>
                        <p
                            className={SV.detailHeaderValue}
                            style={{ fontSize: '14px', fontWeight: '500', marginLeft: '8px' }}
                        >
                            {TimeHelper.formatDate(summary?.periodBeginDate)} -{' '}
                            {TimeHelper.formatDate(summary?.periodEndDate)}
                        </p>
                    </Box>
                    {summary?.summaryItems?.length ? (
                        <ReceiptRenderer
                            data={summary.summaryItems}
                            summaryInfo={summary}
                            setIsLoading={setIsLoading}
                            setSummary={setSummary}
                            getSummaryList={getSummaryList}
                        />
                    ) : null}
                </Box>
            </Box>
        </Box>
    ) : (
        <></>
    );
};
